export function buildRequestPrefill (newData = {}, group = {}) {
  const customerInfo = newData.customer_info || {}
  const section = newData.section || {}
  const programInfo = section.program_info || newData.program_info || {}
  const bundle = newData.bundle || {}
  const placement = newData.placement || {}
  const technique = placement.technique || newData.technique || {}
  const location = placement.location || newData.location || {}
  const styles = Array.isArray(newData.styles) ? newData.styles : []

  const customerName = customerInfo.customer_name || newData.customer_name || newData.account_name || ''
  const customerNumber = customerInfo.customer_number || newData.customer_number || newData.account_number || newData.account_num || ''
  const programName = newData.program_name || programInfo.program_name || ''
  const sectionName = newData.section_name || section.name || ''
  const bundleName = newData.bundle_name || bundle.name || ''
  const placementName = newData.bundle_placement_name || placement.name || placement.placement_label || ''
  const techniqueName = newData.technique_name || technique.technique_name || ''
  const locationName = newData.location_name || location.location_name || ''
  const locationCode = newData.location_code || location.location_code || ''
  const artworkName = newData.artwork_name || placement.artwork_name || ''
  const notes = [newData.notes, placement.notes, section.notes].filter(Boolean)
  const styleSummary = styles
    .map(style => {
      const styleName = style.style_name || style.style_description || ''
      const units = parseInt(style.units || 0)
      return styleName ? `${styleName}${units > 0 ? ` (${units})` : ''}` : ''
    })
    .filter(Boolean)

  const titleParts = [programName, bundleName, placementName].filter(Boolean)
  const comments = []
  if (notes.length) {
    comments.push(notes.join('\n\n'))
  }
  if (styleSummary.length) {
    comments.push(`Styles: ${styleSummary.join(', ')}`)
  }
  if (artworkName) {
    comments.push(`Artwork: ${artworkName}`)
  }

  return {
    customerName,
    customerNumber,
    accountName: customerName,
    accountNumber: customerNumber,
    programName,
    sectionName,
    bundleName,
    placementName,
    techniqueName,
    locationName,
    locationCode,
    artworkName,
    title: titleParts.join(' - ') || artworkName || bundleName || placementName || '',
    reference: artworkName || placementName || '',
    comments: comments.join('\n\n'),
    styles,
    ccNumber: group.cc_number || newData.cc_number || '',
    logNumber: group.as400_log_number || newData.log_number || '',
    orderId: newData.order_id || '',
  }
}
